import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants';
import { prepareResponseFailure } from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { WaitingPackingProductsByActorsGroupDto } from '@/types/PackingParcel';

const ENDPOINT = `${APIConfiguration.carrier}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/packing/waiting-products`;

interface GetWaitingPackingProductsBySellerQueryArgs {
  sellerId: string;
}

async function getWaitingPackingProductsBySellerQuery({
  sellerId,
}: GetWaitingPackingProductsBySellerQueryArgs): Promise<
  BackResponse<WaitingPackingProductsByActorsGroupDto[]> | BackResponseFailure
> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId);

    const response = await apiCall<
      BackResponse<WaitingPackingProductsByActorsGroupDto[]>
    >(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getWaitingPackingProductsBySellerQuery;
